module.exports = __webpack_public_path__ + "img/921_page_background3.c9d5a188.jpg";